<template>
  <footer class="footer mt-auto py-3">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center">
        <div class="text-muted">&copy; Digital Innovation Hub - {{ currentYear }}</div>

        <b-nav align="right">
          <b-nav-item>Privacy policy</b-nav-item>
          <b-nav-item>Cookie policy</b-nav-item>
          <b-nav-item>Termini e condizioni</b-nav-item>
        </b-nav>
      </div>
    </div>
  </footer>
</template>

<script>
/*
  The footer of the website
*/

export default {
  name: 'Footer',
  computed: {
    // retrieve the current year with the Date object
    currentYear: () => new Date().getFullYear()
  }
}
</script>

<style scoped>
.footer {
  z-index: 1;
}
</style>
